import React, { memo } from "react";
import {
  Button,
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "../../../components/ui";
import { Loader2, Check, X } from "lucide-react";

const AdminLeadRow = memo(({ 
  lead,
  onClick,
  approving,
  rejecting,
  showApproveDialog,
  showRejectDialog,
  onApprove,
  onReject,
  onOpenApproveDialog,
  onOpenRejectDialog
}) => (
  <tr 
    className="hover:bg-gray-50 transition-colors cursor-pointer"
    onClick={() => onClick(lead)}
  >
    <td>{new Date(lead.created_at).toLocaleString()}</td>
    <td>{lead.leadmaker_name || lead.leadmaker_id.slice(0,8)}</td>
    <td>{lead.customer?.customer_segment}</td>
    <td>₹{(parseFloat(lead.total_value) || 0).toFixed(2)}</td>
    <td>
      <span className={`status-text status-${lead.status}`}>
        {lead.status}
      </span>
    </td>
    <td>₹{(parseFloat(lead.commission_amount) || 0).toFixed(2)}</td>
    <td className="actions" onClick={(e) => e.stopPropagation()}>
      <AlertDialog open={showApproveDialog} onOpenChange={onOpenApproveDialog}>
        <AlertDialogTrigger asChild>
          <Button 
            size="sm" 
            disabled={lead.status !== 'pending' || approving}
            className="bg-green-600 hover:bg-green-700"
          >
            {approving ? (
              <>
                <Loader2 className="h-3 w-3 mr-1 animate-spin" />
                Approving...
              </>
            ) : (
              <>
                <Check className="h-3 w-3 mr-1" />
                Approve
              </>
            )}
          </Button>
        </AlertDialogTrigger>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Approve Lead</AlertDialogTitle>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction 
              onClick={onApprove}
              className="bg-green-600 hover:bg-green-700"
            >
              Approve Lead
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <AlertDialog open={showRejectDialog} onOpenChange={onOpenRejectDialog}>
        <AlertDialogTrigger asChild>
          <Button 
            size="sm" 
            variant="destructive"
            disabled={lead.status !== 'pending' || rejecting}
          >
            {rejecting ? (
              <>
                <Loader2 className="h-3 w-3 mr-1 animate-spin" />
                Rejecting...
              </>
            ) : (
              <>
                <X className="h-3 w-3 mr-1" />
                Reject
              </>
            )}
          </Button>
        </AlertDialogTrigger>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Reject Lead</AlertDialogTitle>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction 
              onClick={onReject}
              className="bg-red-600 hover:bg-red-700"
            >
              Reject Lead
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </td>
  </tr>
));

AdminLeadRow.displayName = 'AdminLeadRow';

export default AdminLeadRow;


